// hooks/usePageTitle.js
import { useEffect } from 'react';

const SITE_NAME = 'GForce Solutions';

const usePageTitle = (title, description) => {
    useEffect(() => {
        document.title = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | CRM, SaaS, Web & Mobile App Development`;

        if (description) {
            const meta = document.querySelector('meta[name="description"]');
            if (meta) meta.setAttribute('content', description);
        }
    }, [title, description]);
};

export default usePageTitle;
